import { isEmpty } from 'lodash-es';
import { useState, useEffect } from 'react';
import {
  fetchCandiateFieldMapping,
  candiateDefaultFieldMapping,
  IMappingFormSettingsResponse,
} from 'wisestep-api';

const useMappingFormSettings = () => {
  const [fieldsMap, setFieldsMap] = useState<IMappingFormSettingsResponse>();
  const [status, setStatus] = useState<'success' | 'failed' | 'noResponse'>('noResponse');

  useEffect(() => {
    (async function () {
      try {
        const getSubmissionSettingsResponse = await fetchCandiateFieldMapping();
        const fieldMap: IMappingFormSettingsResponse = getSubmissionSettingsResponse?.data;
        if (!isEmpty(fieldMap)) setFieldsMap(fieldMap);
        else {
          const resetDefaultSettingsDetails = await candiateDefaultFieldMapping();
          const defaultFieldsMap: IMappingFormSettingsResponse = resetDefaultSettingsDetails?.data;
          setFieldsMap(defaultFieldsMap);
        }
        setStatus('success');
      } catch (e) {
        setStatus('failed');
      }
    })();
  }, []);

  return { fields: fieldsMap, status };
};

export default useMappingFormSettings;
